/**
 * @desc Yung-审批前事件
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ApprovalBeforeRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/approval/beforeEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
